<template>
  <div class="light exchange-wallet-member-layout">
    <div class="exchange-wallet-member-layout__guests-heading">
      {{ i18n.t("kano.exchange-form.drop-down.member.title") }}
    </div>

    <div class="exchange-wallet-member-layout__guests-heading-btns">
      <a class="button button--primary button--small"
         :href="memberLink">{{ i18n.t("kano.exchange-form.btn.member-area") }}</a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { i18n } from '@kano/i18n';
import { computed } from 'vue';
import UrlHelper from '@/helpers/UrlHelper';
import { Flow } from '@paybis/frontend-common-lib/src/types/exchangeForm/exchange-form';

const props = defineProps<{
  flow: Flow,
  relationLink: string,
}>();


const memberLink = computed(() => {
  return UrlHelper.toPaybisFrontUrl(`member/exchange/${props.relationLink}`, i18n.locale);
});
</script>

<style lang="scss" scoped>
.exchange-wallet-member-layout {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  max-width: 230px;
  margin: 0 auto;

  &__guests-heading {
    color: var(--color-base-48);
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    margin-bottom: 16px;

    &-btns {
      display: flex;
      gap: 8px;
      justify-content: center;
    }
  }
}
</style>
